var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "580px",
    height: "580px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "nonzero",
    clipRule: "nonzero",
    viewBox: "0 0 5800 5800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_cross icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "arrow_cross icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curve28",
    fill: "#000000",
    d: "M4479,3629 5109,3000 3000,3000 3000,5109 3629,4479 3771,4621 2900,5491 2029,4621 2171,4479 2800,5109 2800,3000 691,3000 1321,3629 1179,3771 309,2900 1179,2029 1321,2171 691,2800 2800,2800 2800,691 2171,1321 2029,1179 2900,309 3771,1179 3629,1321 3000,691 3000,2800 5109,2800 4479,2171 4621,2029 5491,2900 4621,3771z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCross);
export default __webpack_public_path__ + "static/media/arrow_cross.d88f91aceae2d93555749a4edb8cebb7.svg";
export { ForwardRef as ReactComponent };